import React, { useState } from 'react';

import ProvideFullAccessModal from './ProvideFullAccessModal/ProvideFullAccessModal';
import UserVerificationStatusForm from './UserVerificationStatusForm';

interface Props {
  hideUserAccess?: boolean;
}

const UserVerificationStatus: React.FC<Props> = ({ hideUserAccess }) => {
  const [isProvideFullAccessModalVisible, setIsProvideFullAccessModalVisible] = useState(false);

  return (
    <>
      <UserVerificationStatusForm
        hideUserAccess={hideUserAccess}
        setIsProvideFullAccessModalVisible={setIsProvideFullAccessModalVisible}
      />
      {isProvideFullAccessModalVisible && (
        <ProvideFullAccessModal onSetVisible={setIsProvideFullAccessModalVisible} />
      )}
    </>
  );
};

export default UserVerificationStatus;
